<template>
    <div class="ui-content dashboard adduser-pg add-user-scroll-tab">
        <div class="page-user">
            <v-tabs
                v-model="tab"
                background-color
                class="elevation-2 cust-tab"
                :centered="centered"
                :grow="grow"
                :vertical="vertical"
                :right="right"
                :prev-icon="
                    prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined
                "
                :next-icon="
                    nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined
                "
                :icons-and-text="icons"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab :href="'#Coordinator'">Coordinator</v-tab>
                <v-tab  :href="'#Student'">Student</v-tab>
                <v-tab :href="'#Parent'">Parent</v-tab>
                <v-tab :href="'#Teacher'">Teacher</v-tab>
                <v-tab :href="'#DEO'">D.E.O</v-tab>
                <v-tabs-items :touchless="true" v-model="tab">
                    <v-tab-item :value="'Coordinator'">
                            <AddUsersCoor :tab="tab"/>
                    </v-tab-item>
                    <v-tab-item :value="'Student'">
                            <AddUsersStudent :tab="tab"/>
                    </v-tab-item>
                    <v-tab-item :value="'Parent'">
                            <AddUsersParents :tab="tab"/>
                    </v-tab-item>
                    <v-tab-item :value="'Teacher'">
                            <AddUsersTeachers :tab="tab"/>
                    </v-tab-item>
                    <v-tab-item :value="'DEO'">
                            <AddUsersDeo :tab="tab"/>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import AddUsersParents from "@/components/coordinator/users/AddUser/AddUsersParents.vue";
import AddUsersCoor from "@/components/coordinator/users/AddUser/AddUsersCoor.vue";
import AddUsersStudent from "@/components/coordinator/users/AddUser/AddUsersStudent.vue";
import AddUsersTeachers from "@/components/coordinator/users/AddUser/AddUsersTeachers.vue";
import AddUsersDeo from "@/components/coordinator/users/AddUser/AddUsersDeo.vue";
import constants from "@/utils/constants.js";

export default {
    name: "AddUser",
    components: {
        AddUsersParents,
        AddUsersCoor,
        AddUsersStudent,
        AddUsersTeachers,
        AddUsersDeo,
    },
    data() {
        return {
            tab: null,
            icons: false,
            centered: false,
            grow: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            tabs: 3,
        };
    },
    mounted() {
        this.defaultData();
        this.checkSessionData();
    },
    methods: {
        ...mapMutations("app", ["addBreadCrumbChilde"]),
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if (crd) {
                this.tab = crd.selectedTab ? crd.selectedTab : "Coordinator";
            }
        },
        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);

            if (rp.params.resetPage || !crd.routeName) {
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: this.tab,
                };
                this.setRouteDetails(routeDetails);
            }
        }
    },
    watch: {
        tab(val, oldVal) {
            if (oldVal) {
                // only when tab is changed and not on page load
                let routeName = this.$route.name;
                this.setRouteDetails({ routeName, selectedTab: val });
            }
            this.addBreadCrumbChilde([
                {
                    text: val,
                    disabled: false,
                },
            ]);
        },
    },
};
</script>
